import { Injectable } from '@angular/core';
import { Test } from '../_model/test';
import { Server } from '../_model/server';
import { Isp } from '../_model/isp';


@Injectable()
export class StoreService {

    servers: Server[] = [];
    testServer: Server = new Server();
    test: Test = new Test();
    server: Server = new Server();
    isp: Isp = new Isp();
    ispName: string;
    isgOffer: any;

    constructor() {
    }
}
